import styled from 'styled-components';
import FacebookLogo from '@/assets/icon/logo_facebook.svg';
import InstaLogo from '@/assets/icon/logo_instagram.svg';
import NaverLogo from '@/assets/icon/logo_naver.svg';
import YoutubeLogo from '@/assets/icon/logo_youtube.svg';

const SnsBanner = ({ iconImageUrl }: { iconImageUrl: string }) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <TitleSectionWrapper>
          <img src={iconImageUrl} width={160} height={160} />
          <TitleSection>
            <Title>제주로렌트카 이야기</Title>
            <Description>제주여행의 정보는 제주로렌트카에서</Description>
          </TitleSection>
        </TitleSectionWrapper>
        <SnsSectionWrapper>
          <SnsIconWrapper>
            <img
              onClick={() => {
                window.open(
                  'https://www.instagram.com/jejurorentcar/',
                  '_blank',
                );
              }}
              src={InstaLogo}
              width={72}
              height={72}
              style={{
                borderRadius: '50%',
                cursor: 'pointer',
              }}
            />
          </SnsIconWrapper>
          <SnsIconWrapper>
            <img
              onClick={() => {
                window.open(
                  'https://www.facebook.com/jejurorentcar/',
                  '_blank',
                );
              }}
              src={FacebookLogo}
              width={72}
              height={72}
              style={{
                borderRadius: '50%',
                cursor: 'pointer',
              }}
            />
          </SnsIconWrapper>
          <SnsIconWrapper>
            <img
              onClick={() => {
                window.open('https://blog.naver.com/jejurotravel', '_blank');
              }}
              src={NaverLogo}
              width={72}
              height={72}
              style={{
                borderRadius: '50%',
                cursor: 'pointer',
              }}
            />
          </SnsIconWrapper>
          <SnsIconWrapper>
            <img
              onClick={() => {
                window.open(
                  'https://youtube.com/channel/UCYuW1Pd9kzTIFKe0IrH_sTg?si=P6vy1che201nuaFV',
                  '_blank',
                );
              }}
              src={YoutubeLogo}
              width={72}
              height={72}
              style={{
                borderRadius: '50%',
                cursor: 'pointer',
              }}
            />
          </SnsIconWrapper>
        </SnsSectionWrapper>
      </InnerWrapper>
    </Wrapper>
  );
};

export default SnsBanner;

const Wrapper = styled.div`
  display: flex;
  width: 1200px;
  padding: 20px 40px;
  margin-top: 40px;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid var(--mono-000-stroke, #eee);
  background: var(--Color, #fff);

  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.24);
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
`;

const TitleSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const Title = styled.p`
  color: #333;
  font-size: 30px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.45px;
`;

const Description = styled.p`
  color: #505050;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.27px;
`;

const SnsSectionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
`;

const SnsIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;
